import { NeutralNotice } from '@seller/ui/NeutralNotice';
import { useLocation } from 'react-router';

export function CatalogSaveNotice() {
  const location = useLocation();
  const saved = location.state?.catalogSaved === true;
  return <NeutralNotice className="catalog-save-notice">{saved ? 'Изменения сохранены' : null}</NeutralNotice>;
}
